/**
 * 디자인 토큰 원시값. (provisional — 스크린샷 근사치, HTML 확보 시 재검증 필요)
 * 컴포넌트에서 직접 import 금지. 반드시 theme 경유.
 */

export const color = {
  // ── 브랜드 ──────────────────────────
  /** 주 액션. Synchronize 버튼, 활성 토글, 사이드바 선택 항목, 활성 탭에 활용. */
  primary: '#029A80',
  /** primary 면 위 글자색. 대비 확보용이라 흰색 고정. */
  onPrimary: '#FFFFFF',
  /**
   * 보조 액션. 보조 버튼 테두리·문구, 부가 컨트롤에 활용.
   * 시안에 근거 없음 — primary(청록·고채도)와 대조해 같은 한색 계열의
   * 저채도 슬레이트로 도출한 값. 실제 브랜드 가이드 확보 시 교체.
   */
  secondary: '#64748B',
  /** primary 연한 면. 활성 메뉴 배경, 선택 행 hover에 활용. */
  primarySoft: '#E6F4F1',

  // ── 표면 ────────────────────────────
  /** 페이지 바탕. surface보다 한 톤 어둡게 두어 카드가 떠 보이는 효과. */
  bg: '#F5F6F8',
  /** 카드·패널·입력 컨트롤 바탕. 대시보드에서 가장 넓게 깔리는 면에 활용. */
  surface: '#FFFFFF',
  /** 경계선. 카드 테두리, 드롭다운 테두리, 탭 구분선에 공통 활용. */
  border: '#E5E7EB',
  /** 상단 내비게이션 바 전용 바탕. 다른 자리에 재사용 금지. */
  navBg: '#12172B',
  /** navBg 면 위 글자색. */
  onNav: '#FFFFFF',

  // ── 글자 ────────────────────────────
  /** 본문·패널 제목. 기본 글자색. 애매하면 이 값. */
  text: '#333B49',
  /** 보조 라벨, 축 눈금, 비활성 탭에 활용. */
  textMuted: '#8B93A1',

  // ── 상태 ────────────────────────────
  /** 정상·성공. Correct 스탯 타일 테두리·수치에 활용. 체크포인트 A 결정으로 primary와 동일 값 통합. */
  success: '#029A80',
  /** 재시도 성공. success와 같은 초록 계열이되 한 톤 밝게 — 히트맵에서 순수 성공과 구분. */
  success2: '#34C7A6',
  /** 경고. Warning 스탯 타일 테두리·수치에 활용. */
  warning: '#F4C542',
  /** 오류·감소. 증감 하락 표시, 도넛 Error 세그먼트에 활용. */
  danger: '#E0393E',
  /** 진행 중. RUNNING 배지, 진행 수치, 히트맵 진행 셀에 활용. */
  running: '#1E88E5',
} as const;

/**
 * 데이터 시각화 전용 팔레트. 브랜드 색과 분리 관리.
 * primary 판정에서 제외한 색 — UI 컨트롤에 사용 금지.
 */
export const chart = {
  /** KPI 게이지 채움. 화면에서 면적이 가장 넓지만 브랜드 색 아님. */
  gauge: '#1E88E5',
  /** 월별 KPI 막대에 활용. */
  series1: '#26A69A',
  /** 도넛 세그먼트. 상태색과 값이 겹치나 의도적으로 별도 유지. */
  donut: {
    correct: '#1E88E5',
    warning: '#F4C542',
    error: '#FB8C00',
    fatal: '#E0393E',
  },
} as const;

export const space = {
  /** 4px. 아이콘과 글자처럼 붙은 요소 간격에 활용. */
  xs: 4,
  /** 8px. 라벨과 값 사이, 버튼 안쪽 상하 여백에 활용. */
  sm: 8,
  /** 16px. 기본값. 애매하면 이 값. 카드 안쪽 여백, 카드 사이 간격에 활용. */
  md: 16,
  /** 24px. 섹션 내 블록끼리 벌릴 때 활용. */
  lg: 24,
} as const;

export const radius = {
  /** 4px. 버튼, 입력, 드롭다운에 활용. */
  sm: 4,
  /** 8px. 카드·패널에 활용. */
  md: 8,
  /** pill 형태. 세그먼트 토글, 게이지 월 배지에 활용. */
  pill: 999,
} as const;

export const fontSize = {
  /** 12px. 축 눈금, 보조 라벨에 활용. */
  sm: 12,
  /** 14px. 기본 본문·컨트롤 글자. 애매하면 이 값. */
  md: 14,
  /** 16px. 패널 제목에 활용. */
  lg: 16,
  /** 22px. 스탯 타일 수치에 활용. */
  xl: 22,
} as const;
